import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { PlayerMinutes } from "@components/PlayerRetiredStats/PlayerMinutes"
import { PlayerMatches } from "@components/PlayerRetiredStats/PlayerMatches"
import { PlayerGoals } from "@components/PlayerRetiredStats/PlayerGoals"
import { PlayerFouls } from "@components/PlayerRetiredStats/PlayerFouls"

export function PlayerRetiredStats({
  minutes,
  assists,
  yellowCards,
  redCards,
  goals,
  penaltyGoals,
  matchesPlayed,
  startingElevenMatches,
}: {
  minutes: number
  assists: number
  yellowCards: number
  redCards: number
  goals: number
  penaltyGoals: number
  matchesPlayed: number
  startingElevenMatches: number
}) {
  return (
    <Col>
      <Row>
        <Col className={"centerColumn"}>
          <PlayerMinutes minutes={minutes} assists={assists} />
        </Col>
      </Row>
      <Row>
        <Col md={6} className={"centerColumn"}>
          <PlayerMatches matchesPlayed={matchesPlayed} startingElevenMatches={startingElevenMatches} />
        </Col>
        <Col md={6} className={"centerColumn"}>
          <PlayerGoals goals={goals} penaltyGoals={penaltyGoals} />
        </Col>
      </Row>
      <Row>
        <Col className={"centerColumn"}>
          <PlayerFouls yellowCards={yellowCards} redCards={redCards} />
        </Col>
      </Row>
    </Col>
  )
}
